var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 426.667 426.667",
    style: {
      enableBackground: "new 0 0 426.667 426.667"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M298.667,234.667c11.733,0,21.333-9.6,21.333-21.333v-192C320,9.6,310.4,0,298.667,0H21.333C9.6,0,0,9.6,0,21.333V320     l85.333-85.333H298.667z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#D34F7E"
    },
    "data-old_color": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.333,85.333h-42.667v192H85.333V320c0,11.733,9.6,21.333,21.333,21.333h234.667l85.333,85.333v-320     C426.667,94.933,417.067,85.333,405.333,85.333z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#D34F7E"
    },
    "data-old_color": "#000000"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.ae3e17a4.svg";
export { ForwardRef as ReactComponent };